export const TEST_ID = 'navigationBoldText';
